@tailwind base;
@tailwind components;
@tailwind utilities;

/* Scoped reset — applies only to elements inside our modal host. We don't
   want to touch anything on the Shopify page outside #woman-checkout-embed-host. */

#woman-checkout-embed-host,
#woman-checkout-embed-host * {
  box-sizing: border-box;
}

#woman-checkout-embed-host {
  font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  line-height: 1.5;
  color: #1a1a1a;
}

#woman-checkout-embed-host button,
#woman-checkout-embed-host input,
#woman-checkout-embed-host select,
#woman-checkout-embed-host textarea {
  font: inherit;
  color: inherit;
  margin: 0;
}

#woman-checkout-embed-host button {
  cursor: pointer;
  background: none;
  border: 0;
  padding: 0;
}

#woman-checkout-embed-host h1,
#woman-checkout-embed-host h2,
#woman-checkout-embed-host h3,
#woman-checkout-embed-host p,
#woman-checkout-embed-host label,
#woman-checkout-embed-host span {
  margin: 0;
}

#woman-checkout-embed-host a {
  color: inherit;
}

/* Modal scroll container — always render a visible scrollbar so users
   (especially on mobile, where overlay scrollbars hide by default) can tell
   the content is scrollable. `overflow-y: scroll` reserves the gutter even
   when the content fits; the styled track + thumb stay quietly present and
   become obviously functional once content overflows. */
#woman-checkout-embed-host .wco-scroll {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #9ca3af #f4f4f4;
}
#woman-checkout-embed-host .wco-scroll::-webkit-scrollbar {
  -webkit-appearance: none;
  width: 10px;
}
#woman-checkout-embed-host .wco-scroll::-webkit-scrollbar-track {
  background: #f4f4f4;
}
#woman-checkout-embed-host .wco-scroll::-webkit-scrollbar-thumb {
  background: #9ca3af;
  border: 2px solid #f4f4f4;
  border-radius: 8px;
}
#woman-checkout-embed-host .wco-scroll::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}
